<script setup lang="ts">
import BackButton from './BackButton.vue';

withDefaults(
  defineProps<{ tall?: boolean; backTo?: string; backLabel?: string }>(),
  { tall: false },
);
</script>

<template>
  <header
    class="bg-carte border-filet flex shrink-0 items-center gap-3 border-b px-4 sm:gap-[14px] sm:px-5"
    :class="tall ? 'h-[88px]' : 'h-[72px]'"
  >
    <BackButton :to="backTo" :label="backLabel" />
    <div class="flex min-w-0 flex-1 items-center gap-3">
      <slot />
    </div>
    <div class="flex shrink-0 items-center gap-3">
      <slot name="aside" />
    </div>
  </header>
</template>
